import { forwardRef } from 'react';
import { cn } from '@newcore/ui/cn';
import { Sizes } from '@newcore/ui/enums/sizes';
import * as svgIcons from '../../../assets/icons';

type IconName = keyof typeof svgIcons;

export interface SvgIconProps extends React.SVGProps<SVGSVGElement> {
  name: IconName;
  size?: Sizes.SM | Sizes.MD | Sizes.LG | Sizes.XL;
  onClick?: () => void;
}

export const SvgIcon = forwardRef<SVGSVGElement, SvgIconProps>(
  (
    { name, size = Sizes.MD, onClick, className, ...props },
    ref
  ): React.ReactElement | null => {
    const Icon = svgIcons[name];

    if (!Icon) {
      console.error(`Icon ${String(name)} not found`);

      return null;
    }

    const sizeClasses: Record<
      Sizes.SM | Sizes.MD | Sizes.LG | Sizes.XL,
      string
    > = {
      [Sizes.SM]: 'w-4 h-4',
      [Sizes.MD]: 'w-5 h-5',
      [Sizes.LG]: 'w-6 h-6',
      [Sizes.XL]: 'w-8 h-8',
    };

    return (
      <Icon
        {...props}
        ref={ref}
        className={cn(
          sizeClasses[size],
          className,
          Boolean(onClick) && 'cursor-pointer hover:text-primary'
        )}
        data-name={name}
        onClick={onClick}
      />
    );
  }
);

SvgIcon.displayName = 'SvgIcon';
